<template>
	<div class="loginIm">
		<div @click="closeLg()" style="width: 30px;height: 20px;float: right; text-align: center;line-height: 20px;">
			<i class="el-icon-close"></i>
		</div>
		<div style="text-align: center;padding: 20px 0;color: #409EFF;">登录-客汇宝</div>
		<el-tabs id="tabs" v-model="activeName" @tab-click="handleClick" style="padding: 0 5%;">
			<el-tab-pane label="密码登录" name="first">
				<loginpass></loginpass>
			</el-tab-pane>
			<el-tab-pane label="验证码登录" name="second">
				<loginyzm></loginyzm>
			</el-tab-pane>
			<el-tab-pane label="扫码登录" name="third">
				<!-- <div style="padding: 20px 0;height: 20px;text-align: center;">
					请扫描下方二维码
					
				</div> -->
				<div v-show="xianshizhezhao"
					style="width: 250px;height: 250px; background: darkgray; margin-left: 15%;margin-bottom:20px;text-align: center;line-height: 250px;opacity: 0.3;">
					已扫描
				</div>
				<div style=" text-align: center;" v-show='saomiao'>
					<img style="width: 250px;height: 250px;background-size:auto;margin-bottom:20px;"
						:src="this.erweimaimgs" alt="">
				</div>
			</el-tab-pane>
		</el-tabs>


		<!-- <div v-show="erweimas" style="height:300px;">
			
			<span @click="xianshi" style="float: right; display: block; width: 20px;height: 20px;margin-top: 10px;margin-right: 10px;"><i
				class="el-icon-close"></i></span>
			<div style="padding: 20px 0;height: 20px;text-align: center;">
				请扫描下方二维码
				
			</div>
			<div v-show="xianshizhezhao" style="width: 250px;height: 250px; background: darkgray; margin-left: 20%;text-align: center;line-height: 250px;opacity: 0.3;">
					已扫描
			</div>
			<div style=" text-align: center;" v-show='saomiao'>
				<img style="width: 250px;height: 250px;background-size:auto" :src="this.erweimaimgs" alt="">
			</div>
		</div> -->
		<!-- <div v-show="change">
			<loginyzm v-if="changego"></loginyzm>
		<loginpass v-else></loginpass>
		
		<div class="change" >
			<span v-if="changego" @click="changego=false">密码登录</span>
			<span v-else @click="changego=true">验证码登录</span>			
		</div>
		</div>	 -->
		<!-- <div  @click="erweima()" style="padding-top: 10px;text-align: center;padding-bottom: 15px;">二维码登录</div> -->
	</div>
</template>

<script>
	import qs from "qs"
	import loginyzm from '@/components/im/loginyzm'
	import loginpass from '@/components/im/loginpass'
	import { getMimcInfo } from '@/xiaomi/mimc.js';
	export default {

		components: {
			loginyzm,
			loginpass,
		},
		data() {
			return {
				activeName: 'first',
				saomiao: true,
				xianshizhezhao: false,
				change: true,
				// changego:false,
				erweimas: false,
				websock: null,
				wsid: '',
				erweimaimg: '',
				erweimaimgs: '',
				wPath: '',
				protocols: '',
			}
		},
		// created() {
		//   this.initWebSocket();
		// },
		destroyed() {
			//   this.websock.close() //离开路由之后断开websocket连接
			//   this.websocketclose()
		},
		methods: {
			//   随机生成六位数
			MathRand() {
				var Num = '';
				for (var i = 0; i < 33; i++) {
					Num += Math.floor(Math.random() * 10);
					this.wsid = Num
				}
				// console.log(555,this.wsid)
			},
			//   点击x关掉
			closeLg() {
				this.$parent.loginShowClose();
				this.saomiao = true
				this.xianshizhezhao = false
			},
			//   选项卡点击事件
			handleClick(tab, event) {
				// console.log(tab, event);
				if (tab.name == 'third') {
					// 触发‘配置管理’事件
					this.MathRand()
					this.erweima();
				} else if (tab.name == 'first') {
					this.erweimaxian();
				} else if (tab.name == 'second') {
					this.erweimaxian();
				}


			},
			erweimaxian() {
				this.saomiao = true
				this.xianshizhezhao = false
			},
			myimshows() {
				this.saomiao = true
				this.xianshizhezhao = false
			},
			setcookie(name, value) {
				//设置名称为name,值为value的Cookie
				var expdate = new Date();   //初始化时间
				expdate.setTime(expdate.getTime() + 24 * 7 * 60 * 60 * 1000);   //时间单位毫秒 过期时间30分钟
				document.cookie = name + "=" + escape(value) + ";expires=" + expdate.toGMTString() + ";path=/";
			},
			getCookie(c_name) {
				//判断document.cookie对象里面是否存有cookie
				if (document.cookie.length > 0) {
					var c_start = document.cookie.indexOf(c_name + "=")
					//如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
					if (c_start != -1) {
						c_start = c_start + c_name.length + 1
						var c_end = document.cookie.indexOf(";", c_start)
						if (c_end == -1) c_end = document.cookie.length
						return unescape(unescape(document.cookie.substring(c_start, c_end)))
					}
				}
				return ""
			},
			initWebSocket() { //初始化weosocket
				var wsid = this.wsid
				var wsuri = this.protocols + this.wPath + wsid;
				// if (this.$store.state.logindenglu == false) {
				// 	var wsuri =this.protocols+this.wPath+wsid;
				// 	console.log(1111,wsuri)
				// }else {
				// 	// var wsuri = "ws://ooo2.xinwuka.com:8089/wbs/"+wsid;
				// 	var wsuri = "ws://www.kehuibao.cn/wbs/"+wsid; //www.kehuibao.cn  替换当前网站域名
				// }			
				this.websock = new WebSocket(wsuri);
				this.websock.onmessage = this.websocketonmessage;
				this.websock.onopen = this.websocketonopen;
				this.websock.onerror = this.websocketonerror;
				this.websock.onclose = this.websocketclose;

			},
			websocketonopen() { //连接建立之后执行send方法发送数据
				// console.log('发送数据')
				// let actions = {"wsid":"123"};
				// this.websocketsend(JSON.stringify(actions));
			},
			websocketonerror() {//连接建立失败重连
				this.initWebSocket();
			},
			websocketonmessage(e) { //数据接收
				// console.log(777, e.data)
				var redata = JSON.parse(e.data)

				if (redata.type == 'LOGIN_SCAN') {

					this.xianshizhezhao = true
					this.saomiao = false
					// this.setcookie('mytokenIm',redata.token)
					// this.setcookie('accountIm',redata.account)
					// this.setcookie('conNumIm',redata.conNum)
					// this.userInfo()

				} else if (redata.type == 'LOGIN_CONFIRM') {
					// this.setcookie('mytokenIm',redata.token)
					// this.setcookie('accountIm',redata.account)
					// this.setcookie('conNumIm',redata.conNum)phoneIm
					this.setcookie('mytokenIm', redata.token)
					this.setcookie('phoneIm', redata.account)
					this.setcookie('conNumIm', redata.conNum)
					this.setcookie('userInfo', JSON.stringify(redata.userInfo))
					this.$store.commit('loginTrueFc', true)
					localStorage.setItem("loginTrue", "yes");
					this.$parent.loginShowClose();
					this.xianshizhezhao = false
					getMimcInfo(redata.account, function (status) {
						if (status) {
							this.$message("登录成功");
							this.$parent.logingo();

							// this.logingo()

						} else {
							this.$message.error('登录失败');
						}
					})
					// this.$parent.logingo();
					// this.erweimas = false
					this.xianshizhezhao = false
					this.$router.push({ name: 'Chatwindow' })
				}
			},
			websocketsend(Data) {//数据发送
				// console.log('数据发送', Data)
				this.websock.send(Data);
			},
			websocketclose(e) {  //关闭
				// console.log('断开连接',e);
			},
			xianshi() {
				this.change = true
				this.erweimas = false
			},
			logingo() {
				this.$parent.logingo();
			},
			loginShowClose() {
				this.$parent.loginShowClose();
			},
			//请求显示二维码
			erweima() {

				// this.erweimas = true
				// this.change = false

				let params = qs.stringify({
					wsid: this.wsid,
				})
				this.$axios.post('/goods/userma/user/loginQrCode/v1', params)
					.then(userData => {
						// console.log(333,userData)
						if (userData.data.resultCode == '0000') {
							this.erweimaimg = userData.data.resultInfo.img
							this.erweimaimgs = "data:image/png;base64," + userData.data.resultInfo.img
							this.initWebSocket()

						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})

			}
		},
		created: function () {
			let protocol = location.protocol === 'https:' ? 'wss:' : 'ws:'
			this.protocols = protocol
			var url = '//' + window.location.host + '/wbs/'
			this.wPath = url
			// this.wPath = 'ws://www.kehuibao.cn/wbs/'

		},
	}
</script>
<style scoped>
	.change {
		text-align: center;
		padding-bottom: 15px;
	}

	#tabs .el-tabs__item {
		text-align: center !important;
		font-size: 20px !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/im/loginIm.vue